<script setup lang="ts">
import { Typography } from 'src/shared/ui/typography';

withDefaults(
  defineProps<{
    value: string;
    label: string;
    mutedSuffix?: string;
  }>(),
  { mutedSuffix: '' },
);
</script>

<template>
  <div class="result-metric">
    <Typography variant="h6" as="p" class="result-metric__value">
      {{ value }}
      <span v-if="mutedSuffix" class="result-metric__suffix" data-part="suffix">
        {{ mutedSuffix }}
      </span>
    </Typography>
    <Typography variant="caption-2" as="p" class="result-metric__label">{{ label }}</Typography>
  </div>
</template>

<style scoped>
.result-metric {
  min-width: 0;
}

.result-metric__value,
.result-metric__label {
  margin: 0;
}

.result-metric__value {
  color: var(--palette-graphite-dark);
  white-space: nowrap;
}

.result-metric__suffix {
  color: var(--palette-graphite);
  font: var(--font-body-l);
  font-weight: 400;
}

.result-metric__label {
  color: var(--palette-graphite);
}
</style>
